export const validateType = (extensions, fileName) => {
    const fileExtension = fileName.split(".").pop().toLowerCase();
    return extensions.map(ext => ext.toLowerCase()).includes(fileExtension);
};